<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 追溯查询 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <div v-if="editModel">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
        >
          <el-form-item label="兽药追溯码查询" prop="zsmCode">
            <el-input
              :rows="2"
              type="textarea"
              v-model="editModel.zsmCode"
              placeholder="请输入兽药追溯码"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="float: right; margin-bottom: 20px">
          <el-button type="primary" :loading="loading" @click="queryClick">
            查询
          </el-button>
        </div>
      </div>
    </el-card>
    <el-card v-if="zsmInfo" shadow="hover">
      <div style="padding: 20px; min-height: 100px">
        <div v-if="zsmInfo.warehouseList && zsmInfo.warehouseList.length > 0">
          <div class="query-result-title">
            <span>出入库记录</span>
          </div>
          <template v-for="warehouseZsm in zsmInfo.warehouseList">
            <warehouse-zsm-info :zsmInfo="warehouseZsm" />
          </template>
        </div>
        <div class="query-result-title">
          <span>追溯查询结果</span>
        </div>
        <vet-zsm-info :zsmInfo="zsmInfo" />
      </div>
    </el-card>
    <el-card v-else shadow="hover">
      <div style="padding: 20px; min-height: 100px">
        <el-empty
          :description="errorMsg || '请输入兽药追溯码查询'"
          :image-size="100"
        >
        </el-empty>
      </div>
    </el-card>
  </div>
</template>

<style scoped>
.query-result-title {
  color: #919191;
  margin-bottom: 10px;
  font-size: 16px;
}
</style>

<script>
import vetZsmInfo from '../../../../components/business/vetZsmInfo.vue';
import warehouseZsmInfo from '../../../../components/business/warehouseZsmInfo.vue';

export default {
  components: {
    vetZsmInfo,
    warehouseZsmInfo
  },
  data() {
    return {
      zsmInfo: null,
      loading: false,
      errorMsg: null,
      editModel: {
        zsmCode: ""
      },
      editRules: {
      },
    }
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  methods: {
    queryClick() {
      if (this.editModel.zsmCode) {
        this.zsmInfo = null;
        this.errorMsg = null;
        this.loading = true;
        return this.requestApi('biz.data.vet.zsm.info.query', {
          zsmCode: this.editModel.zsmCode,
        }).then((resp) => {
          this.loading = false;
          this.zsmInfo = resp.data;
        }).catch((err) => {
          this.loading = false;
          this.errorMsg = (err && err.msg) || (err && err.message)
            || '连接服务器失败，请检查网络';
        });
      } else {
        this.loading = false;
        this.errorMsg = null;
        this.zsmInfo = null;
      }
    },
    handleScaning() {

    },
    handleScan(value) {
      this.editModel.zsmCode = value;
      this.queryClick();
    }
  },
  created() {
    this.editModel = { zsmCode: "" }
  },
  mounted() {
    this.onScan(this.handleScan);
    this.onScaning(this.handleScaning);
  },
  destroyed() {
    this.offScan(this.handleScan);
    this.offScaning(this.handleScaning);
  }
}
</script>